import { render, staticRenderFns } from "./BrandingHint.vue?vue&type=template&id=5c4727d6&scoped=true"
var script = {}
import style0 from "./BrandingHint.vue?vue&type=style&index=0&id=5c4727d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4727d6",
  null
  
)

export default component.exports